import { fetchConToken, fetchConTokenFiles } from '../../helpers/fetch';
import { handleErrorApi } from '../../helpers/randoms';
import { types } from '../../types/types';
import { startAlerta } from '../ui/alertas';
import { finishSpinner, startSpinner } from '../ui/spinner';

//DOCUMENTACION

export const cleanDocumentacionOdontoHCE = () => ({
  type: types.documentacionOdontoHCEClean,
});
export const errorDocumentacionOdontoHCE = () => ({
  type: types.documentacionOdontoHCEError,
});
export const getDocumentacionOdontoHCE = (body) => ({
  type: types.documentacionOdontoHCESucces,
  payload: body,
});
export const postDocumentacionOdontoHCE = (body) => ({
  type: types.documentacionOdontoHCEInsert,
  payload: body,
});
export const deleteDocumentacionOdontoHCE = (id) => ({
  type: types.documentacionOdontoHCEEliminar,
  payload: id,
});

export const TraerDocumentacionOdontologia =
  (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    if (idAfiliado === null) {
      idAfiliado = 0
    }
    if (idAfiliadoExterno === null) {
      idAfiliadoExterno = 0
    }
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `HCEDocumentacionOdontologia/${idAfiliado}/${idAfiliadoExterno}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(getDocumentacionOdontoHCE(body));
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch(errorDocumentacionOdontoHCE());
      handleErrorApi(
        dispatch,
        error,
        'Error al traer documentacion',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const setDocumentacionOdontologia = (
  formData,
  idTipoDoc,
  idAfiliado,
  idAfiliadoExterno
) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConTokenFiles(
        `HCEDocumentacionOdontologia/${idTipoDoc}/${idAfiliado}/${idAfiliadoExterno}`,
        formData,
        'POST',
        dispatch,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(postDocumentacionOdontoHCE(body));
        dispatch(
          startAlerta(
            'Datos Guardados Exitosamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al guardar el documento.',
        'Ha ocurrido un error. Intente nuevamente.',
      );
    }
  };
};

export const deleteDocumentoOdontologia = (idDocumentacionHCE) => {
  ;
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `HCEDocumentacionOdontologia/${idDocumentacionHCE}`,
        {},
        'DELETE',
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(deleteDocumentacionOdontoHCE(idDocumentacionHCE));
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            'Documento Eliminado Exitosamente',
            'success',
            'Comando Exitoso',
          ),
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al eliminar el documento.',
        'Ha ocurrido un error. Intente nuevamente.',
      );
    }
  };
};
